type BreadcrumbsParents = {
  label: string
  url: string
}

type Breadcrumbs = {
  label: string
  parents?: BreadcrumbsParents[]
}

export function useBreadcrumbs() {
  const breadcrumbs = useState('breadcrumbs', () => ref<Breadcrumbs | null>(null))

  function setBreadcrumbs(newBreadcrumbs: Breadcrumbs) {
    breadcrumbs.value = newBreadcrumbs
  }

  const previousPage = computed(() => {
    return breadcrumbs.value?.parents?.slice(-1)?.pop() || null
  })

  const { t } = useI18n({ useScope: 'global' })
  const { public: config } = useRuntimeConfig()
  const breadcrumbList = computed(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'name': t('Home'),
          'item': config.productionUrl,
        },
        ...(breadcrumbs.value?.parents || []).map((breadcrumb, index) => {
          return {
            '@type': 'ListItem',
            'position': index + 2,
            'name': breadcrumb.label,
            // item: (config.productionUrl + breadcrumb.url).replace(/(?<!:)\/\/+/g, '/')
            'item': (config.productionUrl + breadcrumb.url).replace(/\/+/g, '/').replace(':/', '://'), // Safari compatible version
          }
        }),
        ...(breadcrumbs.value
          ? [{
              '@type': 'ListItem',
              'position': 2 + (breadcrumbs.value?.parents?.length || 0),
              'name': breadcrumbs.value?.label,
            }]
          : []),
      ],
    }
  })
  return {
    breadcrumbList,
    breadcrumbs,
    setBreadcrumbs,
    previousPage,
  }
}
